import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import CountBadgeWithTooltip from "../CountBadgeWithTooltip";
import { TaskTypeCompatibilitiesProps } from "./types";

const TaskTypeCompatibilities = ({
    taskTypes
}: TaskTypeCompatibilitiesProps) => {
    const { gray700 } = colors;

    const { t } = useTranslation();

    const supportedTaskTypes = taskTypes.filter(
        ({ task_support }) => task_support
    );

    const total = supportedTaskTypes.length;

    return (
        <CountBadgeWithTooltip
            count={total}
            tooltip={
                <ul
                    css={css({
                        maxHeight: "240px",
                        overflowY: "auto",
                        marginRight: "-16px",
                        padding: "0 16px",

                        "& > li": {
                            listStyle: "revert"
                        },

                        "& > li + li": {
                            marginTop: "4px"
                        },

                        "&::-webkit-scrollbar-thumb": {
                            borderColor: gray700
                        }
                    })}
                >
                    {supportedTaskTypes.map(({ id, task_type }) => (
                        <li key={id}>{t(`General##${task_type}`)}</li>
                    ))}
                </ul>
            }
        />
    );
};

export default TaskTypeCompatibilities;
